<template>
    <div>
        <app-title text="PQR's por resolver" />
        <b-row>
            <b-col cols="12" lg="4">
                <app-form-select-input
                    placeholder="Tipo"
                    :options="types"
                    v-model="filters.type"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" lg="1">
                <b-button variant="primary" class="btn-block" @click="filter"
                    ><i class="fa fa-filter"></i
                ></b-button>
            </b-col>
            <b-col cols="12" md="4" lg="1">
                <b-button
                    variant="secondary"
                    class="btn-block"
                    @click="clearFilters"
                    ><i class="fa fa-times-circle"></i
                ></b-button>
            </b-col>
        </b-row>
        <br />
        <app-table-tasks-list
            :data="data"
            :on-change-page="onChangePage"
            :see-comments-by-petition="seeCommentsByPetition"
            :see-more="seeMore"
            :start-add-comment="startAddComment"
            :start-upload-files="startUploadFiles"
            :start-mark-resolved="startMarkResolved"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up
            title="Comentarios de la petición"
            size="large"
            id="view-comments-petition-my-tasks"
        >
            <div class="body" slot="body">
                <app-petition-comments-list
                    :onRemove="onRemoveComment"
                    :comments="commentsPetitionSelect"
                />
            </div>
        </app-pop-up>

        <app-pop-up id="view-petition-more-my-tasks" title="Petición">
            <div slot="body">
                <div class="row">
                    <div class="col-6">
                        <h5>Fecha de creación</h5>
                        <label>{{ petitionView.date | datetime }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Tipo de petición</h5>
                        <label>{{ petitionView.type }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Cliente</h5>
                        <label>{{ petitionView.client }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuario</h5>
                        <label>{{ petitionView.user }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Estado</h5>
                        <label>{{ petitionView.status }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuarios asignados</h5>
                        <div v-if="petitionView.assignments">
                            <div v-for="assignment in petitionView.assignments">
                                {{
                                    assignment.inactive
                                        ? assignment.user.name
                                        : assignment.user.name +
                                          " (Actualmente)"
                                }}
                            </div>
                        </div>
                        <div v-if="!petitionView.assignments.length">
                            No tiene
                        </div>
                    </div>
                </div>
                <br />
                <h5 style="text-align:center">
                    <label for="anotation">Descripción</label>
                </h5>
                <textarea
                    type="text"
                    id="anotation"
                    class="form-control"
                    disabled="true"
                    cols="80"
                    rows="8"
                    v-model="petitionView.description"
                ></textarea>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar comentario a la petición"
            id="petition-comment-my-tasks"
            :onClose="cleanFormComment"
        >
            <div class="body" slot="body">
                <app-add-petition-comment
                    id="petition-comment-my-tasks"
                    :petition="petitionComment"
                    :on-save="onSaveComment"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('petition-comment-my-tasks.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Subir archivos a la petición"
            id="petition-files-my-tasks"
            :onClose="cleanFiles"
        >
            <div class="body" slot="body">
                <app-upload-files
                    id="petition-files-my-tasks"
                    title="Adjunte archivos relacionados a la solución de la petición"
                    v-model="petitionFiles.files"
                ></app-upload-files>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="uploadFiles(petitionSelectUploadFiles)"
                    :disabled="inProgress"
                >
                    Subir
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Aprobación de petición"
            id="mark-resolved-petition-my-tasks"
            :onClose="cleanMarkResolved"
        >
            <div class="body" slot="body">
                <h5>
                    ¿Esta seguro que desea marcar como resuelta esta petición?
                </h5>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="resolvedPetition(markResolvedPetition)"
                >
                    Aceptar
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import petitionsRepository from "../../../repositories/petitions.repository.js";
import SubTitle from "../../UI/Layout/SubTitle.vue";
import AddPetitionComment from "../../ClientService/PetitionComment/AddPetitionComment.vue";
import UploadFiles from "../../UI/Controls/Files/UploadFiles.vue";
import TableTasksList from "./TableTasksList/TableTasksList.vue";
import PetitionCommentsList from "../../ClientService/PetitionComment/PetitionCommentsList";

export default {
    components: {
        appSubTitle: SubTitle,
        appAddPetitionComment: AddPetitionComment,
        appUploadFiles: UploadFiles,
        appTableTasksList: TableTasksList,
        appPetitionCommentsList: PetitionCommentsList
    },

    data() {
        return {
            page: 1,
            data: {},
            petitionComment: {},
            commentsPetitionSelect: [],
            petitionView: {
                user: "",
                client: "",
                type: "",
                date: "",
                description: "",
                status: "",
                assignments: []
            },
            filters: {
                type: ""
            },
            petitionFiles: {
                files: "",
                userId: "",
                petitionId: ""
            },
            petitionSelectUploadFiles: {},
            sort: {
                sortBy: "created_at",
                sortDir: "asc"
            },
            types: []
        };
    },

    methods: {
        clearFilters() {
            Object.keys(this.filters).map(key => (this.filters[key] = ""));
            this.loadPetitionsByUser();
        },
        filter() {
            this.loadPetitionsByUser();
        },
        async loadPetitionTypes() {
            const { data } = await repo.get(
                "petitions/types",
                null,
                "Lo sentimos, ha ocurrido un error"
            );
            this.types = data;
        },
        petitionColorStatus(petition) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dueDate = new Date(petition.due_date);
            dueDate.setHours(0, 0, 0, 0);
            if (today.getTime() === dueDate.getTime() && petition.resolved != 1)
                return "today";
            if (dueDate.getTime() < today.getTime() && petition.resolved != 1)
                return "overdue";
        },
        loadPetitionsByUser() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir
            };
            const pr = Object.assign({}, petitionsRepository);
            pr.loadPetitionsByUserAssignments(this.user.id, filters, this.page)
                .then(data => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error("Error al cargar las peticiones");
                });
        },
        seeCommentsByPetition(petition) {
            this.commentsPetitionSelect = petition.comments;
            this.$bus.$emit("view-comments-petition-my-tasks.open");
        },
        startAddComment(petition) {
            this.petitionComment = petition;
            this.$bus.$emit("petition-comment-my-tasks.open");
        },
        startUploadFiles(petition) {
            this.petitionFiles.userId = this.user.id;
            this.petitionFiles.petitionId = petition.id;
            this.petitionSelectUploadFiles = petition;
            this.$bus.$emit("petition-files-my-tasks.open");
        },
        startMarkResolved(petition) {
            this.markResolvedPetition = petition;
            this.$bus.$emit("mark-resolved-petition-my-tasks.open");
        },
        onSaveComment() {
            this.$bus.$emit("petition-comment-my-tasks.close");
            this.loadPetitionsByUser();
        },
        cleanFormComment() {
            this.$bus.$emit("petition-comment-my-tasks.clean");
        },
        cleanFiles() {
            this.files = "";
            this.$bus.$emit("petition-files-my-tasks.clean");
        },
        onChangePage(page) {
            this.page = page;
            this.loadPetitionsByUser();
        },
        seeMore(petition) {
            Object.keys(this.petitionView).map(
                key => (this.petitionView[key] = "")
            );
            this.petitionView.user = petition.user.name;
            this.petitionView.client = petition.client.name;
            this.petitionView.type = petition.petition_type.name;
            this.petitionView.date = petition.created_at;
            this.petitionView.description = petition.description;
            this.petitionView.status = petition.petition_status.name;
            this.petitionView.assignments = petition.petition_assignment;

            this.$bus.$emit("view-petition-more-my-tasks.open");
        },
        cleanMarkResolved() {
            this.markResolvedPetition = {};
        },
        resolvedPetition() {
            const formData = new FormData();
            formData.append("userId", this.user.id);

            const pr = Object.assign({}, petitionsRepository);
            pr.markResolvedPetition(this.markResolvedPetition.id, formData)
                .then(data => {
                    if (data.status) {
                        this.markResolvedPetition = {};
                        this.$bus.$emit(
                            "mark-resolved-petition-my-tasks.close"
                        );
                        this.loadPetitionsByUser();
                        this.$bus.$emit("loadNotifications");
                        toastr.success(data.msg);
                    } else {
                        toastr.eror(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No fue posible aprobar la petición");
                });
        },
        uploadFiles(petition) {
            const formData = new FormData();

            formData.append("petitionId", petition.id);
            formData.append("userId", this.petitionFiles.userId);

            if (this.petitionFiles.files.files) {
                this.petitionFiles.files.files.map((item, index) =>
                    formData.append("file" + index, item)
                );
            }
            const pr = Object.assign({}, petitionsRepository);
            pr.uploadFiles(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadPetitionsByUser();
                        this.$bus.$emit("petition-files-my-tasks.close");
                        this.cleanFiles();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "No se pudieron subir los archivos al sistema"
                    );
                });
        },
        onRemoveComment() {
            if (!this.commentsPetitionSelect.length) {
                this.$bus.$emit("view-comments-petition-my-tasks.close");
            }
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadPetitionsByUser();
        }
    },

    created() {
        this.loadPetitionsByUser();
        this.loadPetitionTypes();
    }
};
</script>
